import { BrandSelectionWidget, ProductCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  brand_id: {
    'ui:widget': BrandSelectionWidget,
  },
  category_id: {
    'ui:widget': ProductCategorySelectionWidget,
  },
  introtext: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
